const prefix = 'MASTER/';
export const SET_MASTER_DATA = `${prefix}SET_MASTER_DATA`;

export const masterSelector = ({ masterReducer }) => masterReducer;
